<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col w-full">
          <div class="px-3 lg:px-10 mt-10 pb-2">
            <button
              @click="$router.go(-1)"
              class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-full"
            >
              Back
            </button>
          </div>
          <div>
            <div class="p-3 lg:p-10">
              <div
                class="bg-[#F9FAFC] py-4 px-8 flex flex-col gap-2 md:flex-row flex-wrap items-center justify-between rounded-xl"
              >
                <div class="">
                  <p class="text-lg text-textblues font-semibold">
                    Feedback Details
                  </p>
                </div>
                <div
                  class="flex flex-col md:flex-row flex-wrap gap-5 mt-2 md:mt-0"
                >
                  <div class="w-full md:w-48">
                    <select
                      ref="selectedRating"
                      v-model="selectedRating"
                      @change="getfeedback(1)"
                      class="w-full p-1.5 border border-gray-300 rounded-2xl bg-white"
                      :class="{ 'text-yellow-500': selectedRating }"
                    >
                      <option disabled value="">Rating...</option>
                      <option
                        v-for="i in 5"
                        :key="i"
                        :value="i"
                        class="w-5 h-5"
                      >
                        {{ "⭐".repeat(i) + "☆".repeat(5 - i) }}
                      </option>
                    </select>
                  </div>
                  <div class="flex flex-wrap gap-2">
                    <div class="w-full">
                      <select
                        ref="selectFilter"
                        name="model_select"
                        id="model_select"
                        v-model="selected_filter"
                        @change="getfeedback()"
                        class="px-4 py-2 w-full md:w-[160px] cursor-pointer rounded-full text-sm text-white bg-blues font-semibold focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                      >
                        <option value="" disabled selected>
                          Select sorting
                        </option>
                        <option value="text">A to Z</option>
                        <option value="-text">Z to A</option>
                      </select>
                    </div>
                  </div>
                  <div class="relative max-w-64">
                    <form @submit.prevent="getfeedback">
                      <input
                        type="text"
                        placeholder="Search"
                        id="search"
                        v-model="searching"
                        @input="getfeedback"
                        class="w-full pl-4 pr-10 py-1 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-300"
                      />
                      <button type="submit" class="">
                        <div
                          class="absolute right-3 top-2.5 h-4 w-4 text-gray-400"
                        >
                          <img
                            src="@/assets/search_icon1.svg"
                            alt=""
                            srcset=""
                          />
                        </div>
                      </button>
                    </form>
                  </div>
                  <div>
                    <button
                      @click="clearFilters"
                      class="ml-2 px-3 py-1 bg-blues text-white hover:bg-hover rounded-2xl"
                    >
                      Clear
                    </button>
                  </div>
                  <div
                    @click="fetchdownload()"
                    class="bg-blues text-white rounded-2xl py-1 px-5 flex items-center justify-center gap-2 cursor-pointer"
                  >
                    <img src="@/assets/newd/download1.png" alt="" />
                    <p class="text-sm text-white">Download</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="lg:px-3 px-10 pb-10">
              <div class="grid grid-cols-1 lg:grid-cols-3 gap-10">
                <div
                  class="bg-[#F9FAFC] py-8 px-8 flex flex-col gap-4 items-center justify-center rounded-xl"
                >
                  <p class="font-bold text-center text-[#333333]">
                    Assignment Title
                  </p>
                  <p class="text-sm font-bold text-textblues line-clamp-3">
                    {{ feedback_list.homework_title || "NA" }}
                  </p>
                </div>
                <div
                  class="bg-[#F9FAFC] py-8 px-8 flex flex-col gap-4 items-center justify-center rounded-xl"
                >
                  <p class="font-bold text-center text-[#333333]">
                    Feedback Count
                  </p>
                  <p class="text-sm font-bold text-textblues">
                    {{ feedback_list.feedback_count || 0 }}
                  </p>
                </div>
                <div
                  class="bg-[#F9FAFC] py-8 px-8 flex flex-col gap-4 items-center justify-center rounded-xl"
                >
                  <p class="font-bold text-center text-[#333333]">
                    Averge ratings
                  </p>
                  <div class="text-sm font-bold text-textblues">
                    <div
                      class="flex gap-2 items-center flex-wrap justify-center"
                    >
                      <div class="flex justify-center gap-1">
                        <template v-for="i in 5" :key="i">
                          <svg
                            :class="[
                              'w-6 h-6 transition',
                              i <= feedback_list.average_rating
                                ? 'text-yellow-400'
                                : 'text-gray-300',
                            ]"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.46a1 1 0 00-.364 1.118l1.287 3.976c.3.921-.755 1.688-1.538 1.118l-3.39-2.46a1 1 0 00-1.176 0l-3.39 2.46c-.783.57-1.838-.197-1.538-1.118l1.287-3.976a1 1 0 00-.364-1.118L2.05 9.402c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.975z"
                            />
                          </svg>
                        </template>
                      </div>
                      <p>{{ feedback_list.average_rating || 0 }} Out of 5</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="lg:px-10 lg:rounded-3xl overflow-x-auto">
              <table class="table-auto w-full lg:rounded-3xl">
                <thead>
                  <tr>
                    <th
                      class="p-4 border-b text-center border-r text-textblues bg-[#F9FAFC] whitespace-nowrap"
                    >
                      S NO
                    </th>
                    <th
                      class="p-4 border-b text-center border-r text-textblues bg-[#F9FAFC]"
                    >
                      Name
                    </th>
                    <th
                      class="p-4 border-b text-center border-r text-textblues bg-[#F9FAFC]"
                    >
                      Email
                    </th>
                    <th
                      class="p-4 border-b text-center border-r text-textblues bg-[#F9FAFC]"
                    >
                      Text
                    </th>
                    <th
                      class="p-4 border-b text-center border-r text-textblues bg-[#F9FAFC]"
                    >
                      Rating
                    </th>
                  </tr>
                </thead>
                <tbody
                  v-if="
                    feedback_list.feedbacks && feedback_list.feedbacks.length
                  "
                >
                  <tr v-for="(el, index) in feedback_list.feedbacks" :key="el">
                    <td class="p-4 border-b text-center border-r">
                      <p class="text-primary">{{ index + 1 }}</p>
                    </td>
                    <td
                      class="p-4 border-b text-center border-r whitespace-nowrap"
                    >
                      <p class="text-primary">{{ el.user_name }}</p>
                    </td>
                    <td
                      class="p-4 border-b text-center border-r whitespace-nowrap"
                    >
                      <p class="text-primary">{{ el.user_eamil }}</p>
                    </td>
                    <td
                      class="p-4 border-b text-center border-r lg:max-w-[400px]"
                    >
                      <p class="text-primary line-clamp-3">{{ el.text }}</p>
                      <!-- <p v-else>-</p> -->
                    </td>
                    <td class="p-4 border-b border-r text-center">
                      <div class="flex justify-center gap-1">
                        <template v-for="i in 5" :key="i">
                          <svg
                            :class="[
                              'w-6 h-6 transition',
                              i <= el.rating
                                ? 'text-yellow-400'
                                : 'text-gray-300',
                            ]"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.46a1 1 0 00-.364 1.118l1.287 3.976c.3.921-.755 1.688-1.538 1.118l-3.39-2.46a1 1 0 00-1.176 0l-3.39 2.46c-.783.57-1.838-.197-1.538-1.118l1.287-3.976a1 1 0 00-.364-1.118L2.05 9.402c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.975z"
                            />
                          </svg>
                        </template>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="6" class="px-6 py-3 text-center">
                      No Data Found
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Instructor/SideBar.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  components: {
    SideBar,
  },
  data() {
    return {
      messages: {
        text: "",
        type: "null",
      },
      feedback_list: [],
      selected_filter: "",
      searching: "",
      selectedRating: "",
    };
  },
  created() {
    this.getfeedback();
  },
  // mounted() {
  //   document.addEventListener("click", this.handleClickOutside);
  // },
  // beforeUnmount() {
  //   document.removeEventListener("click", this.handleClickOutside);
  // },

  props: ["course_id", "assignment_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    // handleClickOutside(event) {
    //   const rating = this.$refs.selectedRating;
    //   const filter = this.$refs.selectFilter;

    //   if (
    //     (!rating || !rating.contains(event.target)) &&
    //     (!filter || !filter.contains(event.target))
    //   ) {
    //     this.selected_filter = "";
    //     this.selectedRating = "";
    //     this.getfeedback();
    //   }
    // },
    async getfeedback() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/homework-feedback/summary/course/${this.course_id}/?homework__id=${this.assignment_id}&Key=${this.userInfo.token_key}&search=${this.searching}&ordering=${this.selected_filter}&rating=${this.selectedRating}`
        );

        if (
          res.data &&
          res.data.data &&
          res.data.data.status === 200 &&
          res.data.data.data.length > 0
        ) {
          this.feedback_list = res.data.data.data[0];
          console.log("this.feedback_list", this.feedback_list);
        } else {
          this.feedback_list = { feedbacks: [] };
        }
      } catch (error) {
        console.error("Error fetching feedback:", error);
        this.feedback_list = { feedbacks: [] };
      }
    },

    clearFilters() {
      this.selected_filter = "";
      this.selectedRating = "";
      this.searching = "";
      this.getfeedback();
    },

    async fetchdownload() {
      console.log("this.assignment_id",this.assignment_id)
      try {
        const resp = await axios.get(
          `${process.env.VUE_APP_API}/homework-feedback-csv-link/?course_id=${this.course_id}&homework_id=${this.assignment_id}&Key=${this.userInfo.token_key}`
        );

        if (resp && resp.data && resp.data.download_url) {
          const link = document.createElement("a");
          link.href = resp.data.download_url;
          link.download = resp.data.filename || "feedback.csv";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.response_message =
            "Your file is downloading. You can also check the download history.";
        }
      } catch (err) {
        console.error("Download error:", err);
        this.response_message = "Download failed. Please try again.";
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
